import type { FC } from "react";
import React from "react";
import { Flex, Heading } from "@edreamsodigeo/prisma-design-system";
import { useTranslation } from "@edreamsodigeo/frontend-core";

import type { LightboxOfferDeviceProps } from "~/components/acquisition/Lightbox/LightboxRevamp/components/LightboxOffer/contracts";
import LightboxOfferSubscriptionsDesktop from "~/components/acquisition/Lightbox/LightboxRevamp/components/LightboxOffer/LightboxOfferSubscriptions/LightboxOfferSubscriptionsDesktop";

const LightboxOfferDesktop: FC<LightboxOfferDeviceProps> = ({
  basicOffer,
  plusOffer,
  text,
}) => {
  const { t } = useTranslation();

  return (
    <Flex justifyContent={"space-between"} px={"1x_big"} alignItems={"center"}>
      <Flex justifyContent={"flex-start"}>
        <Heading type={"3"} color={"neutral.90"}>
          {t("lightboxPrimeRevampDesktop.prime.desktop.offer")}
        </Heading>
      </Flex>
      <LightboxOfferSubscriptionsDesktop
        basicOffer={basicOffer}
        plusOffer={plusOffer}
        text={text}
      />
    </Flex>
  );
};

export default LightboxOfferDesktop;
